import React, { FC, useCallback } from 'react';

import ForgotPasswordView from './ForgotPasswordView';

type Props = {
    resetPassword: (email: string) => void;
    onNext?: () => void;
};

const ForgotPassword: FC<Props> = ({ resetPassword, onNext }) => {
    const handleSuccess = useCallback(() => {
        onNext?.();
    }, [onNext]);

    return <ForgotPasswordView resetPassword={resetPassword} onSuccess={handleSuccess} />;
};

export default ForgotPassword;
